import React from "react";
import { createRoot } from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import { ApolloProvider } from "@apollo/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import { apolloClient } from "./lib/apollo";
import { theme } from "./lib/theme";
import { App } from "./App";

import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/spotlight/styles.css";
import "./styles/dark-theme.css";
import "./styles/homepage.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

const container = document.getElementById("root");
if (!container) throw new Error("Root element not found");

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ApolloProvider client={apolloClient}>
          <MantineProvider theme={theme} forceColorScheme="dark">
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </MantineProvider>
        </ApolloProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);
